export const JOB_STATUS = [
  {
    code: 'S1',
    text: 'วันที่นำเครื่องจักรเข้าหน่วยงาน',
  },
  {
    code: 'S2',
    text: 'วันที่เริ่มปฏิบัติงานที่ไม่อยู่ในสัญญา เช่น ตอกเสาเข็มทดสอบ',
  },
  {
    code: 'S3',
    text: 'วันที่เริ่มปฏิบบัติงานที่นับเป็นเวลาตามสัญญา (S3-open วันเริ่มงาน & S3-closed วันจบงาน)',
  },
  {
    code: 'G1',
    text: 'วันที่คาดว่าจะทำงานวันสุดท้าย',
  },
  {
    code: 'H',
    text: 'จำนวนวันที่คาดว่าจะหยุดงานโดยการวางแผนไว้ล่วงหน้า',
  },
]
